/* eslint-disable no-fallthrough */
import React, { Component } from 'react';
import { isURL } from 'validator';
import PropTypes from 'prop-types';
import * as Styled from '../styles';

const InputValidator = (WrappedComponent, type) => {
    class Wrapped extends Component {
        state = {
            error: '',
        };

        componentDidUpdate = (prevProps) => {
            // eslint-disable-next-line react/destructuring-assignment
            if (prevProps.elmIdx !== this.props.elmIdx) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ error: '' });
            }
        };

        validate = (validationType, error) => {
            const { onValidation } = this.props;

            this.setState({ error });

            if (onValidation) {
                onValidation({ type: validationType, isValid: error.length === 0 });
            }
        };

        onChange = (event) => {
            const { onChange } = this.props;
            const { value } = event.target;

            if (type.url) {
                const isURLEncoded = (link) => {
                    return decodeURIComponent(link) !== link;
                }
    
                const validateLink = (link) => {
                    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if (!link) {
                        this.validate('url', 'Please enter a valid link');
                        return;
                    }
                    // if the link starts with mailto: we assume it's an email, we're not validating mailto: links
                    if(link.startsWith('mailto:') || link.startsWith('tel:') || link.startsWith('callto:')) {
                        this.validate('url', '');
                        return;
                    }
                    const isEmail = emailRegex.test(link);
                    const hasProtocol = /:\/\//g.test(link);
                    try {
                        isURLEncoded(link);
                    } catch (error) {
                        this.validate('url', 'Link improperly encoded');
                        return;
                    }
                    const isValidUrl = isURL(link, {
                        protocols: ['http', 'https', 'ftp', 'ibmscp', 'callto:', 'tel:', 'mailto:'],
                        require_protocol: false,
                        require_tld: !hasProtocol,
                    });
            
                    const isFile = link.startsWith('file://');
                    if (isFile) {
                        this.validate('url', 'Not all email clients support file links.');
                    } else if(!isValidUrl) {
                        this.validate('url', 'Please enter a valid link');
                    } else if((link.includes("'") || link.includes('"')) && !isEmail) {
                        this.validate('url', 'Quotation marks have to be encoded');
                    } else {
                        this.validate('url', '');
                        return link;
                    }
                };
                validateLink(value);
            }
            if (type.length) {
                this.validate('length', value.length < type.length ? 'Please enter a value' : '');
            }
            if (type.max) {
                if (value > type.max) {
                    this.validate('max', `Max value is ${type.max}`);
                    return;
                }
                this.validate('max', '');
            }
            onChange(event);
        };

        errorMessage = (required, value, error) => {
            if (required && !value) {
                return <Styled.SurveyRequiredError>Required</Styled.SurveyRequiredError>;
            }
            if (error) {
                return <Styled.InputErrorMsg>{error}</Styled.InputErrorMsg>;
            }
            return null;
        };

        render() {
            const { error } = this.state;
            const { width, label, value } = this.props;

            return (
                <div style={{ width, position: 'relative', marginBottom: 0 }} data-test-id={`${label}-validated-input`}>
                    <WrappedComponent
                        {...this.props}
                        onChange={this.onChange}
                        border={error ? '1px solid #E82E41' : undefined}
                        marginBottom={13}
                    />
                    {this.errorMessage(type.required, value, error)}
                </div>
            );
        }
    }
    Wrapped.propTypes = {
        elmIdx: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        onValidation: PropTypes.func,
        value: PropTypes.string,
        width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        label: PropTypes.string,
    };
    Wrapped.defaultProps = {
        elmIdx: '',
        onValidation: null,
        label: '',
        value: '',
    };
    return Wrapped;
};

export default InputValidator;
